import { Points, PointMaterial } from "@react-three/drei";
import { Track } from "../types";
import { useRef, useState } from "react";
import { Color, Group } from "three";
import { TrackPoint } from "./track-point";
import { TrackLines } from "./track-lines";
import { SelectedPoint } from "./selected-point";

interface TrackSkeletonProps {
  track: Track;
  lines: [number, number][];
  color?: Color | string;
  pointSize?: number;
  lineWidth?: number;
  confidence?: number;
  dashed?: boolean;
  distanceFactor?: number;
  positiveCoords?: boolean;
  lineType?: "segments" | "lines";
  shouldSkipPoint?: (pointIndex: number) => boolean;
  pointPopupContent?: (pointIndex: number) => React.ReactNode;
}

export function TrackSkeleton({
  track,
  lines,
  color,
  pointSize = 0.1,
  lineWidth = 0.015,
  confidence = 0,
  dashed,
  distanceFactor = 2,
  pointPopupContent,
  shouldSkipPoint,
  lineType,
}: TrackSkeletonProps) {
  const object = useRef<Group | null>(null);
  const [selected, setSelected] = useState(-1);

  return (
    <>
      {selected > -1 && (
        <SelectedPoint
          pointPopupContent={pointPopupContent}
          distanceFactor={distanceFactor}
          track={track}
          selectedIndex={selected}
          pointSize={pointSize}
        />
      )}

      <group ref={object}>
        <Points
          frustumCulled={false}
          limit={track.pose_x.length}
          range={track.pose_x.length}
        >
          <PointMaterial
            transparent
            vertexColors
            size={pointSize}
            color={color}
          />
          <TrackPoint
            track={track}
            confidence={confidence}
            shouldSkipPoint={shouldSkipPoint}
            setSelected={setSelected}
          />
        </Points>
        <TrackLines
          type={lineType}
          lines={lines}
          shouldSkipPoint={shouldSkipPoint}
          lineWidth={lineWidth}
          confidence={confidence}
          track={track}
          dashed={dashed}
          color={color}
        />
      </group>
    </>
  );
}
